<template>

             <span class="badge bg-warning"
             >Write-in</span>
</template>

<script>
export default {
    name: "write-in-badge",

    props: [],

    mixins: [],

    data: function () {
        return {}
    },



    computed: {},

    methods: {}

}
</script>

<style >
.badge{
    color: #0a0a0af5;
}

</style>
